import { AgGridAngular } from '@ag-grid-community/angular';
import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  DialogConfig,
  DialogService,
  ModalService,
  ResponsiveService,
  SimpleModalConfig,
  ToggleButton,
} from '@frk/eds-components';

import { AnalyticsService } from '@frk/eds-components';
import { CartHandlerService } from '@literature/services/cart-handler.service';
import { DownloadContentWrapper } from '@literature/services/download';
import { DownloadService } from '@literature/services/download.service';
import { LiteratureDataService } from '@literature/services/literature-data.service';
import { LiteratureGlobalConfigService } from '@literature/services/literature-global-config.service';
import { WINDOW } from '@ng-web-apis/common';
import { SiteConfigService } from '@services';
import { IUserProfile } from '@services/profile.interface';
import { AbstractBaseComponent } from '@shared/abstract-base/abstract-base.component';
import { TranslateService } from '@shared/translate/translate.service';
import {
  CartActionPerformed,
  CartDeliveryMode,
  CartDetails,
  DocumentList,
  LiteratureDocType,
  LiteratureDocument,
  LiteratureDocumentListingState,
  CartCheckoutMode,
} from '@types';
import { Observable, Subject, Subscription } from 'rxjs';
import { filter, shareReplay, takeUntil } from 'rxjs/operators';

const THUMBNAIL_TYPES = {
  presentation: 'PRESENTATION',
  postcard: 'POSTCARD',
  pitchbook: 'PRODUCT-PITCHBOOK',
};
export interface RadioaData {
  radioTitle1: string;
  radioSubTitle1: string;
  radioTitle2: string;
  radioSubTitle2: string;
  radioTitle3: string;
  radioSubTitle3: string;
}
@Component({
  selector: 'ft-literature-document-cart',
  templateUrl: './literature-document-cart.component.html',
  styleUrls: ['./literature-document-cart.component.scss'],
})
export class LiteratureDocumentCartComponent
  extends AbstractBaseComponent
  implements OnInit, OnDestroy {
  columnDefs = [];
  rowData = [];
  gridData: Array<LiteratureDocument & { imageLayout?: string }> = [];
  overAllQty = 0;
  cardViewData: DocumentList[] = [];
  subcription: Subscription;
  dataLoaded = false;
  deliveryOption = '3';
  eventId = 'literature_download';
  engagementLabel: string;
  eventParams = {
    location: '',
    file_name: 'FranklinTempleton_Literature',
    file_extension: 'zip',
  };
  config: DialogConfig = {
    hideFooter: true,
    closeBtnLabel: 'close',
  };
  // this regex is temporary will be removed when eds is available with complete requirement
  regexp = new RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  isValid = true;
  isDisabled = true;
  recipientId: string;
  emailStatus: string;
  @ViewChild('cartGrid', { static: false })
  cartGrid: AgGridAngular;
  isHandheld$: Observable<boolean>;
  isMobile$: Observable<boolean>;
  btnLabel2: string;
  download$: Observable<DownloadContentWrapper>;
  cartQuantityMap = new Map<string, number>();
  cartSubscription: Subscription;
  clientUseNotApproved = true;
  clientNotApprovedMsg: string;
  clientNotApprovedMsgDetail: string;
  mandatoryMaterialTitle: string;
  hardCopyNotAvailable: boolean;
  hardCopyNotAvailableMsg: string;
  hardCopyNotAvailableTitle: string;
  mandatoryMaterialMsg: string;
  hardCopyNotAvailableCount = 0;
  clientUseNotApprovedCount = 0;
  dialogMandatoryMaterials: LiteratureDocument[] = [];
  mandatoryMaterialMap: Map<string, LiteratureDocument>;
  profile: IUserProfile;
  emailToDisplay: string;
  allDocsInCartUnableToDownload = false;
  private unsubscribe$: Subject<void> = new Subject<void>();
  modalIdValue: string;
  modalTitle: string;
  dynamicBodyTextToAppend: string;
  toggleButtons: Array<ToggleButton>;
  isSiteIntl: boolean;
  imageLayout: string;
  itemInCart: number;

  public numberPattern = '^(100|[1-9]?[0-9])$';
  isValidCartQty: boolean;

  constructor(
    private translateService: TranslateService,
    private cartService: CartHandlerService,
    private changeDetectorRef: ChangeDetectorRef,
    private responsiveService: ResponsiveService,
    protected dialogService: DialogService,
    private modalService: ModalService,
    @Inject(WINDOW) readonly windowRef: Window,
    protected downloadService: DownloadService,
    private literatureConfig: LiteratureGlobalConfigService,
    private analytics: AnalyticsService,
    private literatureDataService: LiteratureDataService,
    private siteConfigService: SiteConfigService
  ) {
    super();
    this.isHandheld$ = this.responsiveService.isHandheld$();
    this.isMobile$ = this.responsiveService.isMobile$();
  }

  ngOnInit(): void {
    this.setBreadcrumbItems();
    this.setToggleOption();
    this.prepareLabels();
    this.literatureDataService
      .getProfileData$()
      ?.pipe(
        takeUntil(this.unsubscribe$),
        filter((profile: IUserProfile): boolean => {
          if (profile.isLoggedIn) {
            return !!profile?.profileInfo?.userId;
          } else {
            return true;
          }
        })
      )
      .subscribe((profile: IUserProfile) => {
        this.profile = profile;
      });
    this.cartSubscription = this.cartService
      .getCartItems()
      .subscribe((state: LiteratureDocumentListingState) => {
        this.dataLoaded = true;
        this.gridData = state.cartItems;
        this.countItemInCart(CartDeliveryMode.displayInEmail);
        this.checkDocumentAlertMsg();
        this.updateOverAllQty();
        this.prepareCardView();
        this.isAllDocsInCartUnableToDownload();
        this.changeDetectorRef.detectChanges();
      });
    this.isSiteIntl = this.siteConfigService.isSiteInternational();
    if (!this.isSiteIntl) {
      this.imageLayout = 'portrait';
    }
  }

  updateOverAllQty() {
    this.overAllQty = this.cartService.getOverAllQuantity(this.gridData);
  }

  setToggleOption() {
    this.toggleButtons = [
      {
        active: true,
        text: this.translateService.instant('literature.EMAIL'),
        value: '3',
      },
      {
        active: false,
        text: this.translateService.instant('literature.mail-to-address'),
        value: '1',
      },
      {
        active: false,
        text: this.translateService.instant('literature.download-title'),
        value: '2',
      },
    ];
  }
  /**
   * count Item In Cart
   * @param mode string
   */
  private countItemInCart(mode: string): void {
    if (this.gridData?.length) {
      this.itemInCart = this.gridData.filter((item) => item[mode]).length;
    }
  }

  isAllDocsInCartUnableToDownload() {
    const docs = this.gridData.filter(
      (data) =>
        // if printOnly is 'Y', we dont filter out that object
        // this covers scenarios where printOnly is 'N' and undefined
        data?.downloadUrl
    );
    this.allDocsInCartUnableToDownload = docs?.length === 0;
  }
  prepareCardView() {
    this.gridData.forEach((data: LiteratureDocument) => {
      this.cardViewData.push({
        itemCardView: {
          label: this.translateService.instant('literature.quantity'),
          size: 'compact',
        },
        docId: data.docId,
        client: data.clientUse,
        name: data.fundName,
        hardCopyNotAvailable: data.hardCopyNotAvailable,
        isMandatoryMaterial: data.isMandatoryMaterial,
        mandatoryMaterialDependentMsg: data.mandatoryMaterialDependentMsg,
        quantity: data.quantity,
        reOrderQty: data.reOrderQty,
        mandatoryMaterialPrimary: data.mandatoryMaterialPrimary,
        mandatoryMaterial: data.mandatoryMaterial,
        imageUrl: data.imageUrl,
        fileExtension: data.fileExtension,
      });
    });
  }
  checkDocumentAlertMsg() {
    this.hardCopyNotAvailableCount = 0;
    this.mandatoryMaterialMap = new Map();
    for (const data of this.gridData) {
      // set default quantity as 1 in map to update quantity in storage later
      this.cartQuantityMap.set(data.docId, data.quantity);
      if (data.hardCopyNotAvailable) {
        this.hardCopyNotAvailableCount++;
        // to set quantity 0 as these items does not qualify for checkout
        this.cartQuantityMap.set(data.docId, 0);
      }
      // prepare mandatory material mapping with its parent documents
      if (data.isMandatoryMaterial) {
        data.mandatoryMaterial.forEach((docId: string) => {
          this.mandatoryMaterialMap.set(docId, data);
        });
      }
    }
    // update quantity in storage as its updated for hardcopyNotAvailable docs
    this.cartService.updateCartItemQuantity(this.cartQuantityMap);
    for (const entry of this.mandatoryMaterialMap.entries()) {
      this.gridData.forEach((data: LiteratureDocument) => {
        if (entry[0] === data.docId) {
          data.mandatoryMaterialPrimary = entry[1].fundName;
        }
      });
    }
  }

  showEmptyCartDailog(event: MouseEvent) {
    event?.preventDefault();
    event?.stopPropagation();
    this.modalIdValue = 'emptyCartDailog';
    const config: SimpleModalConfig = {
      modalId: 'cartModal',
      type: 'simple',
      themeTitle: 'dark',
    };
    this.modalService.open('cartModal', config);
  }

  emptyCart(event: string) {
    this.cartService.emptyCartStorage();
    this.analytics.trackEvent({
      event: 'cart_engagement',
      action: 'empty cart',
      number_files: this.gridData?.length,
    });
    this.gridData = [];
    this.close('cartModal');
  }

  getReorderQuantity(qty) {
    if (qty) {
      return { value: qty, label: `${qty}` };
    }
  }
  deleteDocument(data: LiteratureDocument, event: MouseEvent) {
    event?.preventDefault();
    event?.stopPropagation();
    if (data.isMandatoryMaterial) {
      this.showMandatoryConformationDialog(data);
      return;
    }
    // prevent deletion of mandatory documents if its parent is available in cart
    if (this.mandatoryMaterialMap.has(data.docId)) {
      const parentData = this.mandatoryMaterialMap.get(data.docId);
      // to check if parent is already deleted
      if (
        this.gridData.findIndex(
          (litData) => litData.docId === parentData.docId
        ) > -1
      ) {
        this.gridData.find((childNode: LiteratureDocument) => {
          if (childNode.docId === data.docId) {
            childNode.mandatoryMaterialDependentMsg = `${this.translateService.instant(
              `literature.you-must`
            )} ${parentData.fundName} ${this.translateService.instant(
              `literature.before-you-remove`
            )}`;
          }
        });
        this.cardViewData.find((childNode: DocumentList) => {
          if (childNode.docId === data.docId) {
            childNode.mandatoryMaterialDependentMsg = `${this.translateService.instant(
              `literature.you-must`
            )} ${parentData.fundName} ${this.translateService.instant(
              `literature.before-you-remove`
            )}`;
          }
        });
        return;
      }
    }
    this.delete([data.docId]);
    this.analytics.trackEvent({
      event: 'cart_engagement',
      action: 'remove from cart',
      file_name: data?.dctermsTitle,
      file_lit_code: data?.docId,
    });

    // GA4 new analytic event
    this.analytics.trackEvent({
      event: 'cart_remove',
      detailed_event: 'Cart Remove',
      event_data: {
        cart_type: 'Add To Cart',
        file_lit_code: data?.docId,
        file_name: data?.dctermsTitle,
      },
    });
    this.changeDetectorRef.detectChanges();
  }
  // handle hardcopy count with deletion of related documents
  // 0 index of array gives document which have hardcopy not availbale.
  // not handling dependent documents hardcopy check as only primary will be covered.
  delete(docIds: string[]) {
    const deletedIds = this.cartService.inclueMandatoryItems(docIds);
    this.gridData.find((litData) => {
      if (deletedIds?.includes(litData.docId)) {
        if (
          litData.hardCopyNotAvailable &&
          this.hardCopyNotAvailableCount !== 0
        ) {
          this.hardCopyNotAvailableCount--;
        }
      }
    });
    this.cartService.removeFromCart(
      docIds,
      CartActionPerformed.DELETED_FROM_YOUR_CART
    );
    this.isAllDocsInCartUnableToDownload();
    this.updateOverAllQty();
  }
  removeMandatoryMaterial() {
    this.delete(this.dialogMandatoryMaterials?.map((data) => data.docId));
    this.modalService.close('cartModal');
  }
  updateDeliveryOption(event: ToggleButton): void {
    this.deliveryOption = event.value;
    if (event.value === '1') {
      this.btnLabel2 = this.translateService.instant(
        'literature.lit-listing-next'
      );
      this.countItemInCart(CartDeliveryMode.displayInMail);
      this.gridData.forEach((row: LiteratureDocument) => {
        if (row.displayInMail) {
          row.isInvalidQty = row.quantity ? false : true;
          row.invalidQtyMessage = row.quantity
            ? ''
            : this.translateService.instant(
                'literature.quantity-field-error-message'
              );
        }
      });
      this.isValidCartQty = this.isValidCartQuantity();
    } else if (event.value === '2') {
      this.btnLabel2 = this.translateService.instant(
        'literature.download-file'
      );
      this.countItemInCart(CartDeliveryMode.displayInDownload);
    } else {
      this.btnLabel2 = this.translateService.instant(
        'literature.email-literature'
      );
      this.countItemInCart(CartDeliveryMode.displayInEmail);
    }
  }
  /**
   * Updates quantity of selected document
   * @param docId document Id
   * @param value Quantity value
   */
  updateQuantity(docId: string, value: string) {
    const qtyValue = this.handleQuantity(value);
    this.cartQuantityMap.set(docId, qtyValue);
    this.cartService.updateCartItemQuantity(this.cartQuantityMap);
    this.updateOverAllQty();
  }
  /**
   * email validation
   * @param emailId emailId
   */
  checkEmail(emailId) {
    this.recipientId = emailId;
    if (emailId && !this.regexp.test(emailId)) {
      this.isValid = false;
      this.isDisabled = true;
    } else {
      this.isValid = true;
      this.isDisabled = false;
      if (!emailId) {
        this.isDisabled = true;
      }
    }
  }
  handleDelivery(): void {
    if (this.deliveryOption === '2') {
      const literatureCodes = [];
      this.gridData.forEach((node) => {
        // we can't push all mandatoryMaterail, we need to push it if displayInDownload true for that materail
        if (node?.displayInDownload) {
          literatureCodes.push(node?.docId);
        }
      });

      this.modalTitle = this.translateService.instant('literature.downloading');
      this.modalIdValue = 'downloadProgressModal';
      this.openModal('cartModal');

      // this.dialogService.open('progressDownload');
      this.isDisabled = true;
      this.downloadService
        .download$(this.cartService.getDownloadUrl(), {
          literatureCodes: [...literatureCodes],
        })
        .pipe(shareReplay(1))
        .subscribe(
          (data) => {
            this.isDisabled = false;
            if (data?.state === 'DONE') {
              this.modalTitle = this.translateService.instant(
                'literature.lit-sticky-success-modal-title'
              );
              this.closeModal('cartModal');
              this.modalIdValue = 'successModal';
              this.openModal('cartModal');
              this.changeDetectorRef.detectChanges();
            }
          },
          (err) => {
            // Handle Failure
            this.handleDownloadFailure();
          }
        );
      this.placeOrder(CartCheckoutMode.DOWNLOAD);
    } else if (this.deliveryOption === '3') {
      // we can't push all mandatoryMaterail for email, we need to push it if displayInEmail true for that materail
      const filteredData = this.gridData.filter((node) => {
        return node.displayInEmail;
      });
      this.isDisabled = true;
      this.cartService
        .sendEmail$(filteredData, this.recipientId, this.profile?.profileInfo)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (data) => {
            // Handle Success of the email service
            this.dynamicBodyTextToAppend = this.recipientId;
            this.modalTitle = this.translateService.instant(
              'literature.lit-sticky-success-modal-title'
            );
            this.modalIdValue = 'emailSentModal';
            this.openModal('cartModal');
            this.changeDetectorRef.detectChanges();
            this.isDisabled = false;
          },
          (err) => {
            // Handle Failure
            this.isDisabled = false;
            this.modalTitle = this.translateService.instant(
              'literature.email-failure-title'
            );
            this.modalIdValue = 'emailFailureModal';
            this.openModal('cartModal');
            this.changeDetectorRef.detectChanges();
          }
        );
      this.placeOrder(CartCheckoutMode.EMAIL);
    } else {
      this.cartService.updateCartItemQuantity(this.cartQuantityMap);
      this.literatureConfig.navigateToUrl(
        this.literatureConfig.navigationUrls?.orderCheckoutAddress
      );
    }
    this.cartEngagement();
  }

  handleDownloadFailure() {
    this.isDisabled = false;
    this.modalTitle = this.translateService.instant(
      'literature.download-failure-title'
    );
    this.modalIdValue = 'downloadFailureModal';
    this.openModal('cartModal');
    this.changeDetectorRef.detectChanges();
  }

  cartEngagement() {
    switch (this.btnLabel2) {
      case this.translateService.instant('literature.lit-listing-next'):
        this.engagementLabel = 'Direct Mail';
        break;
      case this.translateService.instant('literature.download'):
        this.engagementLabel = 'Download from Cart';
        break;
      case this.translateService.instant('literature.email-literature'):
        this.engagementLabel = 'Email from Cart';
        break;
      default:
        this.engagementLabel = 'Direct Mail';
    }
    const litCode = [];
    const itemIncart = [];
    this.gridData.forEach((node) => {
      litCode.push(node?.docId);
      itemIncart.push(node?.dctermsTitle);
    });
    if (
      this.engagementLabel === 'Download from Cart' ||
      this.engagementLabel === 'Email from Cart'
    ) {
      this.analytics.trackEvent({
        event: 'batch_files',
        action: this.engagementLabel.replace(' from Cart', '').toLowerCase(),
        detailed_event: 'Batch Download or Email',
        event_data: {
          cart_action: this.engagementLabel
            .replace(' from Cart', '')
            .toLowerCase(),
          number_files: itemIncart.length,
        },
        number_files: itemIncart.length,
      });
      this.cartTracking(itemIncart, litCode);
    } else {
      this.cartTracking(itemIncart, litCode);
    }
  }
  private cartTracking(itemIncart: string[], litCode: string[]) {
    this.analytics.trackEvent({
      event: 'cart_engagement',
      action: this.engagementLabel,
      file_name: itemIncart.join('|'),
      file_lit_code: litCode.join('|'),
    });

    // new GA4 event
    this.analytics.trackEvent({
      event: 'cart_complete',
      detailed_event: 'Cart Complete',
      event_data: {
        cart_type: this.engagementLabel,
        file_lit_code: litCode.join('|'),
        file_name: itemIncart.join('|'),
      },
    });
  }

  /**
   * place the order for selected item
   */
  placeOrder(checkoutMode) {
    const orderItems: CartDetails[] = this.gridData.map((item) => {
      return {
        literatureCode: item.docId,
        qty: 1,
      };
    });
    this.cartService.checkoutOrder(orderItems, checkoutMode);
  }
  /**
   * Naviagtes to Literature listing page
   */
  goToLiterature() {
    this.literatureConfig.navigateToUrl(
      this.literatureConfig.navigationUrls?.litListing
    );
  }

  /**
   * Naviagtes to Literature Index page
   */
  goToLiteratureIndex() {
    this.literatureConfig.navigateToUrl(
      this.literatureConfig.navigationUrls?.myLiteratureLandingUrl
    );
  }
  /**
   * Displays confirmation dialog for manadtory material
   * @param data LiteratureDocument
   */
  showMandatoryConformationDialog(data: LiteratureDocument) {
    // popup work
    this.dialogMandatoryMaterials = [];
    this.dialogMandatoryMaterials.push(data); // primary data
    data.mandatoryMaterial?.forEach((docId: string) => {
      this.gridData.find((litData: LiteratureDocument) => {
        if (litData.docId === docId) {
          this.dialogMandatoryMaterials.push(litData);
        }
      });
    });
    const config: SimpleModalConfig = {
      modalId: 'cartModal',
      type: 'simple',
      themeTitle: 'dark',
    };
    this.modalIdValue = 'mandatoryDailog';
    this.modalService.open('cartModal', config);
  }
  close(dailogId: string) {
    this.modalService.close(dailogId);
  }
  /**
   * Gets labels that needs to be displyed based on scenarios
   */
  prepareLabels() {
    this.btnLabel2 = this.translateService.instant(
      'literature.email-literature'
    );
    this.clientNotApprovedMsg = this.translateService.instant(
      `literature.client-not-approved`
    );
    this.clientNotApprovedMsgDetail = this.translateService.instant(
      `literature.client-not-approved-detail`
    );
    this.mandatoryMaterialTitle = this.translateService.instant(
      `literature.this-is-mandatory`
    );
    this.hardCopyNotAvailableMsg = this.translateService.instant(
      `literature.cart-hardcopy-alert-body-msg`
    );
    this.hardCopyNotAvailableTitle = this.translateService.instant(
      `literature.cart-hardcopy-alert-title`
    );
    this.mandatoryMaterialMsg = `${this.translateService.instant(
      `literature.cart-mandatory-alert-detail-msg`
    )}`;
  }
  /**
   * get literature details page link
   * @param url string
   * @returns string
   */
  getLiteratureDetailLink(docId: string): string {
    return `${this.literatureConfig.navigationUrls?.litDetailUrl}/${docId}`;
  }
  /**
   *
   * @param modelId modelId from enum
   * @param title optional if title required
   * opens dialog for dashboard cart
   */
  openModal(modelId: string, title?: string) {
    const config: SimpleModalConfig = {
      modalId: modelId,
      closeBtnLabel: '', // this.modalCloseBtnLabel,
      title: this.modalTitle ? this.modalTitle : title,
      type: 'simple',
      body: '',
      themeTitle: 'dark',
      preTitle: '',
      eventName: 'lightbox_display',
      eventAction: this.modalTitle,
    };
    this.modalService.open(modelId, config);
  }
  /**
   *
   * @param dialogId - dialogId that needs to be closed
   * closes the dailog
   */
  closeModal(modelId: string) {
    this.checkForSuccessfullDelivery();
    this.modalService.close(modelId);
  }

  private checkForSuccessfullDelivery() {
    if (
      this.modalIdValue === 'emailSentModal' ||
      this.modalIdValue === 'successModal'
    ) {
      this.handleSuccessfulEmailDelivery();
    }
  }

  handleEdsCloseEvent(eventId: string): void {
    this.checkForSuccessfullDelivery();
  }

  handleSuccessfulEmailDelivery(): void {
    this.cartService.emptyCartStorage();
    this.dynamicBodyTextToAppend = '';
    this.goToLiteratureIndex();
  }
  onImageLoad($event: any) {
    // TODO - test and consider if we can find parent div element in a cleaner way.

    if ($event.target?.naturalHeight < $event.target?.naturalWidth) {
      const parentDiv = $event.target?.closest('div');
      $event.target.classList.remove('img--expand');
      $event.target.classList.remove('img--full-height');
      parentDiv?.classList?.remove('cart-column--portrait');
      parentDiv?.classList?.add('cart-column--landscape');
    }
  }

  public onQuantityInput(event: Event, data: LiteratureDocument) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.trim()) {
      inputElement.value = this.handleQuantity(inputElement.value).toString();
      data.isInvalidQty = false;
      data.invalidQtyMessage = '';
    } else {
      data.isInvalidQty = true;
      data.invalidQtyMessage = this.translateService.instant(
        'literature.quantity-field-error-message'
      );
    }
    this.isValidCartQty = this.isValidCartQuantity();
  }

  // Limit input to 3 characters and convert to a number (Qty:1 to 100 Max only)
  public handleQuantity(value: string): number {
    const limitedValue = value.slice(0, 3);
    // Convert to a number, and if it's not a valid number, default to 1
    let inputValue = +limitedValue;
    if (isNaN(inputValue)) {
      inputValue = 1;
    }
    // Clamp the value to be between 1 and 100 only.
    inputValue = Math.max(1, Math.min(100, inputValue));
    return inputValue;
  }

  /**
   * Quantity validation
   */
  private isValidCartQuantity(): boolean {
    const numOfInvalidQty = this.gridData.filter(
      (row: LiteratureDocument) => row.displayInMail && row.isInvalidQty
    );
    return numOfInvalidQty.length === 0 ? false : true;
  }

  ngOnDestroy(): void {
    this.cartSubscription?.unsubscribe();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
